export default "__VITE_ASSET__C4T2hFH5__"